var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pwc-thanks-info",style:(_vm.cStyle)},[_c('embed',{staticStyle:{"width":"200px"},attrs:{"src":_vm.submitIcon}}),_c('div',{staticClass:"pwc-info-tilte"},[_vm._v("\n    已提交！\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }